module.exports = __webpack_public_path__ + "img/after.4926182b.jpg";